var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAward = function SvgAward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.667 6.653c0-3.66-3-6.653-6.666-6.653S3.334 2.994 3.334 6.653c0 2.162 1 4.075 2.583 5.239l-.916 7.152a.79.79 0 0 0 .333.831c.25.167.583.167.917 0L10 17.63l3.75 2.245c.083.083.25.083.416.083a.64.64 0 0 0 .417-.166.79.79 0 0 0 .333-.832l-.916-7.068c1.666-1.164 2.666-3.077 2.666-5.24m-11.666 0c0-2.744 2.25-4.99 5-4.99s5 2.246 5 4.99-2.25 4.99-5 4.99-5-2.246-5-4.99m5.416 9.314 2.667 1.58-.583-4.74q-1.126.498-2.5.499-1.375 0-2.5-.5l-.584 4.74 2.667-1.58a.76.76 0 0 1 .833 0",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "award_svg__a",
    width: 14,
    height: 20,
    x: 3,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.667 6.653c0-3.66-3-6.653-6.666-6.653S3.334 2.994 3.334 6.653c0 2.162 1 4.075 2.583 5.239l-.916 7.152a.79.79 0 0 0 .333.831c.25.167.583.167.917 0L10 17.63l3.75 2.245c.083.083.25.083.416.083a.64.64 0 0 0 .417-.166.79.79 0 0 0 .333-.832l-.916-7.068c1.666-1.164 2.666-3.077 2.666-5.24m-11.666 0c0-2.744 2.25-4.99 5-4.99s5 2.246 5 4.99-2.25 4.99-5 4.99-5-2.246-5-4.99m5.416 9.314 2.667 1.58-.583-4.74q-1.126.498-2.5.499-1.375 0-2.5-.5l-.584 4.74 2.667-1.58a.76.76 0 0 1 .833 0",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#award_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 0h20v20H0z",
    clipRule: "evenodd"
  }))));
};
export default SvgAward;